import { Box, Typography } from "@mui/material";
import {studentCorrectedTestQuestion } from "../../interfaces/new-api-interfaces/test";
import i18next from "i18next";

export const YourMarkDisplayer = ({
  question,
}: {
  question: studentCorrectedTestQuestion;
}) => {
  if ((question as any).answer_mark === undefined) {
    return null;
  }
  return (
    <Box>
      <Typography color="primary" fontWeight={600} variant="h5">
        {i18next.language === "ar" ? "العلامة المستحقة: " : "Your Mark : "}
        {(question as any).answer_mark}
      </Typography>
    </Box>
  );
};
